import { Injectable, OnDestroy, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@noda-lib/translate';
import { THashMap } from 'i18n';
import { Observable, Subject } from 'rxjs';

import { DEFAULT_LANG } from '../constants/available-langs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  public readonly langChanges$: Observable<string> = this.translateService.langChanges();
  public langSignal: WritableSignal<string> = signal<string>('');

  constructor(private translateService: TranslateService) {}

  public get activeLang(): string {
    return this.translateService.getActiveLang();
  }

  public get isDefault(): boolean {
    return this.activeLang === DEFAULT_LANG;
  }

  public switch(lang: string): void {
    this.setActive(lang);
  }

  private setActive(lang: string): void {
    this.translateService.setLanguage(lang);
    this.langSignal.set(lang);
  }

  public selectTranslate(key: string, params?: THashMap): Observable<string> {
    return this.translateService.getTranslate$(key, params);
  }

  public getTranslate(key: string, params?: THashMap, lang?: string): string {
    return this.translateService.getTranslate(key, params, lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
